import { companiesCompanyIdCustomDomainsLimits } from "@dashboardApi/apis/companiesCompanyIdCustomDomainsLimits/constants";
import type { GetCustomDomainLimitsResult } from "@dashboardApi/apis/companiesCompanyIdCustomDomainsLimits/types";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

export const getCompaniesCompanyIdCustomDomainsLimits = reactQueryFetcherAdapter(
  companiesCompanyIdCustomDomainsLimits,
  (signal: AbortSignal, companyId: string): Promise<GetCustomDomainLimitsResult> => {
    return fetch(`/companies/${companyId}/custom_domains/limits`, "GET", {}, { signal });
  }
);
